var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.row.info)?_c('div',[_vm._v(" "+_vm._s(_vm.row.info.closed_route ? 'Да' : 'Нет')+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }